import React from 'react';
import StatusGuideBadge from './StatusGuideBadge';

const GuideHeaderCard = ({ item, isCompact = false }) => {
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		const date = new Date(dateString);
		return date.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
	};

	const formatNumber = (num) => {
		if (num === null || num === undefined) return '-';
		return num.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	};

	if (isCompact) {
		return (
			<div className="guide-header-compact d-flex align-items-center gap-2 py-1 px-2 bg-light border-start border-3 border-primary">
				<small className="text-muted">Folio {item.folio}</small>
				<small className="text-muted">|</small>
				<small className="text-muted">{formatDate(item.guide_date)}</small>
				<small className="text-muted">|</small>
				<small className="text-muted">{item.establishment_name}</small>
			</div>
		);
	}

	return (
		<div className="guide-header-card p-2 mb-1 bg-light border rounded">
			<div className="d-flex justify-content-between align-items-start">
				<div className="d-flex align-items-center gap-3">
					<div className="d-flex flex-column">
						<small className="text-muted">Folio</small>
						<strong className="fs-6">{item.folio || '-'}</strong>
					</div>
					<div className="d-flex flex-column">
						<small className="text-muted">Fecha</small>
						<span>{formatDate(item.guide_date)}</span>
					</div>
					<div className="d-flex flex-column">
						<small className="text-muted">Origen</small>
						<span>{item.establishment_name || '-'}</span>
					</div>
					<div className="d-flex flex-column">
						<small className="text-muted">Destino</small>
						<span>{item.final_destination_name || item.warehouse_name || '-'}</span>
					</div>
				</div>
				<div className="d-flex flex-column align-items-end">
					<small className="text-muted">Estado</small>
					<StatusGuideBadge
						name={item.status_guide_name}
						txColor={item.status_guide_txcolor}
					/>
				</div>
			</div>
			<div className="d-flex justify-content-between mt-2 pt-2 border-top">
				<small className="text-muted">
					KG Total Guía: <strong>{formatNumber(item.kilograms_total_guide)}</strong>
				</small>
			</div>
		</div>
	);
};

export default GuideHeaderCard;
